<template>
  <fieldset class="rounded-lg border border-dashed border-argus-forest-500/60 px-5 pb-5 pt-3">
    <legend class="text-xs font-semibold uppercase tracking-wide text-argus-forest-300 px-2">{{ title }}</legend>
    <slot />
  </fieldset>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
  },
}
</script>